"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sportsbook = void 0;
/**
 * Sportsbook providers that can match games with PFFKit analysis.
 */
var Sportsbook;
(function (Sportsbook) {
    /** FanDuel Sportsbook */
    Sportsbook["FanDuel"] = "FD";
})(Sportsbook || (exports.Sportsbook = Sportsbook = {}));
//# sourceMappingURL=sportsbook.js.map